import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import * as FIELD_LABEL from 'constant/form-labels'
import * as NUMBER from 'constant/number'
import React from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const FirstNameInput = ({ disabled = false }) => {
  return (
    <>
      <span>{FIELD_LABEL.FIRST_NAME}</span>
      <Form.Item
        name={FIELD_NAME.FIRST_NAME}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.ONE_HUNDRED)]}
      >
        <Input
          className={styles.form_input}
          disabled={disabled}
          placeholder={'First Name'}
        />
      </Form.Item>
    </>
  )
}

FirstNameInput.propTypes = {
  disabled: PropTypes.bool
}
export default FirstNameInput
